import React from 'react';

const QuoteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    className="position-absolute"
    style={{ opacity: 0.7, left: 5, top: 5, fontSize: 48, color: 'var(--bs-secondary)' }}
  >
    <path d="M9.13456 9H12.1346L10 14.6075H7L9.13456 9Z" fill="currentColor" />
    <path d="M14.1346 9H17.1346L15 14.6075H12L14.1346 9Z" fill="currentColor" />
  </svg>
);

export default QuoteIcon;
